module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_c('defs', [_c('circle', {
    attrs: {
      "id": "a",
      "cx": "40",
      "cy": "40",
      "r": "40"
    }
  })]), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('mask', {
    attrs: {
      "id": "b",
      "fill": "#fff"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#a"
    }
  })]), _c('use', {
    attrs: {
      "fill": "#C4C4C4",
      "fill-rule": "nonzero",
      "xlink:href": "#a"
    }
  }), _c('g', {
    attrs: {
      "mask": "url(#b)",
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#879196",
      "d": "M30.32 56.49h19.76l.05-7.64H30.32z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#E6B693",
      "d": "M31.8 38.28h16.82v22.99H31.8z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M53.07 85.61V54.67L40.21 59.4 27 54.67v30.94z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#627680",
      "d": "M42.35 65.93H38.1l-2.33-6.5h8.92z"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "fill": "#BFBFBF",
      "d": "M29.83 68.51L40.2 59.4 28.4 64.96zM50.6 68.51L40.21 59.4l11.84 5.57z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#627680",
      "d": "M48.97 85.61l-6.9-21.34h-3.7l-6.9 21.34z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M40.21 59.4L30.2 65.15l-2.9-13.26 3.03-3.05zM40.21 59.4l10.03 5.76 2.9-13.26-3.01-3.05z"
    }
  }), _c('path', {
    attrs: {
      "d": "M64.73 85.61c.07-1.06 6.18-26.67 6.18-26.67L52.3 51.07 39.75 85.6h24.98z",
      "fill": "#52325A"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M44.26 85.61c8.61-11.68 14.65-20.19 14.65-20.19l-6.37-3.96a23 23 0 006.93-1.54c-1.06-4.78-7.16-8.85-7.16-8.85L39.75 85.6h4.51z",
      "fill": "#BFBFBF"
    }
  }), _c('path', {
    attrs: {
      "d": "M43.38 85.61A1146.38 1146.38 0 0057.3 64l-4.77-2.53c1.5-1.06 3.1-1.96 4.77-2.69a18.3 18.3 0 00-5-8.36l-12.62 35.2h3.69z",
      "fill": "#52325A"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.52 85.61h24.85L27.83 51.07 9.55 58.94s4.34 15.99 5.73 24.9c.13.58.21 1.17.24 1.77z",
      "fill": "#52325A"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M27.63 61.46l-5.82 3.91s5.62 8.28 14.33 20.3h4.05L27.33 51.56s-5.09 4.02-6.15 8.81a15.3 15.3 0 006.45 1.09z",
      "fill": "#BFBFBF"
    }
  }), _c('path', {
    attrs: {
      "d": "M23.26 63.65s5.54 9.56 13.56 21.96h3.59L27.87 50.48a17.72 17.72 0 00-5.02 8.29c1.69.73 3.29 1.63 4.78 2.69l-4.37 2.2zM15.99 85.61a90.57 90.57 0 00-6.44-26.67S4.17 68.06 3.5 85.6h12.49zM64.48 85.61a90.57 90.57 0 016.46-26.67S76.29 68 76.9 85.6H64.48z",
      "fill": "#52325A"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M40.21 66.41c-.59 0-1.17-.13-1.7-.4a2.1 2.1 0 001.7 1.36c.79-.1 1.45-.63 1.72-1.36-.53.27-1.12.4-1.72.4z",
      "fill": "#BFBFBF"
    }
  })]), _c('circle', {
    attrs: {
      "mask": "url(#b)",
      "cx": "42.39",
      "cy": "40",
      "r": "40"
    }
  }), _c('path', {
    attrs: {
      "fill": "#E6B693",
      "fill-rule": "nonzero",
      "mask": "url(#b)",
      "d": "M44.07 51.13L39.9 58.1 36 51.13v-5.14h8.08z"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M40.02 50.15c-2.38 0-4.03-2.58-4.03-2.58v-1.58h8.08v2.08a5.81 5.81 0 01-4.05 2.08z",
      "fill": "#D0BBAC",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M25.95 35.24C28 44.04 30.14 49 40.05 49c7.88 0 10.9-4.23 13.73-13.64 1.4-4.66-.37-6.87-.37-12.33 0-7.52-5.89-12.54-13.24-12.54-7.76 0-14.2 4.54-14.22 12.54 0 5-.52 9.97 0 12.2z",
      "fill": "#E6B693",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M52.96 30.88c.2-.75.57-1.45 1.05-2.07-.37-1.9-.57-3.83-.6-5.77 0-7.52-5.89-12.54-13.24-12.54-7.76 0-14.2 4.54-14.22 12.54 0 2.23-.11 4.45-.17 6.42.1.06.19.14.25.24.25.33.45.7.58 1.1.98.13 1.53-.2 1.65-.96.12-.77.56-1.54.87-2.3a4.21 4.21 0 013.35-2.47c2.96-.76 5.97-1.38 8.87-2.38 1.34-.47 2.61-1.1 3.78-1.91a6.91 6.91 0 012.14-1.34c3.38-.65 4.2 2.39 4.38 5.03.11 1.54-.19 4.41.73 5.7.18.24.37.48.58.7z",
      "fill": "#DED1C2",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M26.46 29.23a2.32 2.32 0 00-3.3-.85c-1.56.73-.9 6.07.76 6.71 1.64.65 2.54-.18 2.54-.18M53 29.23a2.32 2.32 0 013.29-.85c1.56.73.9 6.07-.76 6.71-1.64.65-2.54-.18-2.54-.18",
      "fill": "#E6B693",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M30.15 27.82c0-.35.12-.68.35-.94a4.78 4.78 0 012.77-.86 3.4 3.4 0 011.76.4c.15.14.1 1.39-.06 1.3a7.26 7.26 0 00-2.01-.5c-.65-.07-1.3.02-1.92.24-.6.18-.97.48-.9.36zM49.05 27.82c.01-.34-.1-.68-.33-.94a4.78 4.78 0 00-2.77-.86c-.62-.03-1.23.1-1.77.4-.14.14-.1 1.39 0 1.3a7.16 7.16 0 012.02-.5c.63-.08 1.28-.01 1.88.2.67.22 1.07.52.97.4z",
      "fill": "#5E3E1A",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M32.66 32.42c.03.34.33.6.68.58a.63.63 0 00.68-.58v-1.63a.63.63 0 00-.68-.58.64.64 0 00-.68.58v1.63z",
      "fill": "#3E2D1E",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M32.9 31.24c0 .2.1.37.22.37s.22-.17.22-.37c0-.2-.1-.39-.22-.39s-.21.2-.21.39z",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M45.18 32.42c.03.34.34.6.68.58.35.02.65-.24.68-.58v-1.63a.64.64 0 00-.68-.58.64.64 0 00-.68.58v1.63z",
      "fill": "#3E2D1E",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M45.37 31.24c0 .2.1.37.22.37s.21-.17.21-.37c0-.2-.1-.39-.21-.39-.12 0-.22.2-.22.39z",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M38.6 35.5c.44-.14.9-.21 1.35-.23.36-.01.71.07 1.03.23 0 0-.54-.87-1.2-.87-.65 0-1.18.87-1.18.87zM38.42 42.85c.83.53 1.9.53 2.73 0-.33.44-.82.73-1.36.8a2.05 2.05 0 01-1.37-.8z",
      "fill": "#D0BBAC",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M35.16 39.26c1.58.3 3.18.46 4.78.47 1.52 0 3.03-.16 4.51-.47 0 0-.32 2.87-4.62 2.87-3.93 0-4.67-2.87-4.67-2.87z",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M34.56 34.46c.11 0 .11.14 0 .14-.12 0-.12-.14 0-.14zM31.86 34.82c.13 0 .13.14 0 .14s-.12-.14 0-.14zM33.87 34.82c.12 0 .12.14 0 .14-.11 0-.13-.14 0-.14zM33.96 34.15c.24 0 .24.29 0 .29s-.25-.3 0-.3zM34.23 34.63v.07s-.07-.07 0-.07zM31.95 34.4v.07s-.06-.07 0-.07zM32.67 34c.06 0 .06.07 0 .07s-.06-.08 0-.08zM32.24 35.07c.06 0 .06.07 0 .07s-.08-.07 0-.07zM32.72 34.78c.06 0 .06.07 0 .07s-.06-.07 0-.07zM33.53 34.63c.17 0 .17.19 0 .19s-.17-.2 0-.2zM33.09 34.3c.2 0 .2.23 0 .23s-.22-.24 0-.24zM33.18 33.96c.13 0 .13.14 0 .14s-.13-.14 0-.14zM32.1 33.84c.21 0 .21.23 0 .23-.2 0-.2-.23 0-.23zM31.58 34.33c.18 0 .18.2 0 .2s-.17-.2 0-.2zM32.4 34.33c.13 0 .22.06.2.15 0 .11-.22.13-.3.06-.09-.07-.06-.19.1-.21zM33.11 34.94c.29 0 .29.33 0 .33s-.3-.33 0-.33zM47.49 34.5c.12 0 .12.15 0 .15s-.13-.14 0-.14zM44.79 34.87c.12 0 .12.14 0 .14s-.12-.14 0-.14zM46.8 34.87c.13 0 .13.14 0 .14-.14 0-.13-.14 0-.14zM46.88 34.2c.25 0 .25.28 0 .28s-.24-.28 0-.28zM47.15 34.71c.07 0 .07.07 0 .07s-.06-.07 0-.07zM45.6 34.04c.06 0 .06.07 0 .07s-.07-.07 0-.07zM45.15 35.12v.07s-.06-.07 0-.07zM45.65 34.83c.06 0 .06.07 0 .07s-.07-.07 0-.07zM46.46 34.63c.15 0 .15.19 0 .19-.16 0-.17-.2 0-.2zM46 34.34c.22 0 .22.24 0 .24-.2 0-.2-.24 0-.24zM46.1 34c.13 0 .13.15 0 .15a.08.08 0 110-.16zM45.03 33.89c.19 0 .19.22 0 .22-.2 0-.2-.22 0-.22zM44.51 34.38c.18 0 .18.2 0 .2s-.18-.2 0-.2zM45.37 34.38c.13 0 .23.06.2.15 0 .1-.2.13-.3.06-.1-.07-.09-.19.1-.21zM46.03 34.99c.3 0 .3.33 0 .33s-.29-.33 0-.33zM24.74 34c-.14-.43-.17-.9-.07-1.36.15-.56.75-1 .72-1.19-.09-.7-.29-1.4-.6-2.03a1.2 1.2 0 00-1.3-.4c-.5.76-.74 1.67-.67 2.57.07-.8.39-1.56.9-2.17.09-.07.55 0 .87.54.25.47.47.97.63 1.5.08.22-.98.28-1.11.84-.13.56.63 1.7.63 1.7zM54.56 34c.14-.43.16-.9.07-1.36-.16-.56-.76-1-.72-1.19.08-.7.28-1.4.6-2.03.3-.39.83-.55 1.3-.4.5.76.74 1.67.67 2.57a3.9 3.9 0 00-.91-2.17c-.08-.07-.55 0-.86.54-.26.47-.47.97-.63 1.5-.09.22.98.28 1.1.84.14.56-.62 1.7-.62 1.7z",
      "fill": "#D0BBAC",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M25.34 28.57a1.72 1.72 0 00-2.19-.19s-1.4-5.61-.38-9.7c1.93-7.74 10-11.1 14.16-11.35s13.35 1.12 13.95 6.04c4.77-1.47 6.1 3.59 6.29 6.3a52.4 52.4 0 01-.88 8.71s-.93-.51-1.2-.33a5.16 5.16 0 00-1.56 2.8c-.34 1.83-1.67.76-1.67.76s1.42-1.57 1.2-7.85c-.1-2.08-.88-6.97-3.16-4.62-1.64-3.69-6.78.75-12.42 3.34-4.7 2.18-8.64 2.2-8.94 2.86-.85 1.94-.4 6.09-.55 6.5-.15.4-1.75.95-1.8.41-.06-.54-.3-3.06-.85-3.68z",
      "fill": "#5E3E1A",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M47.04 28.44c-2.94 0-4.68.53-5.37 1.2a3.4 3.4 0 00-2.1-.58c-.44.05-.85.23-1.2.52-.72-.64-2.38-1.14-5.3-1.14-3.72 0-5.73.98-5.73 1.9 0 1.85.35 6.17 3.59 6.17 3.23 0 5.33-.65 6.6-1.95a5.06 5.06 0 001.2-4.06c.22-.28.55-.46.91-.48.6-.04 1.2.15 1.66.54v.07a5.06 5.06 0 001.2 3.93c1.26 1.3 3.47 1.95 6.6 1.95 3.13 0 3.58-4.32 3.58-6.17.1-.92-1.91-1.9-5.64-1.9zM36.82 33.9c-1.06 1.1-3.05 1.66-5.9 1.66-2.4 0-2.68-3.58-2.7-5.15.25-.3 1.69-1.01 4.78-1.01 3.59 0 4.68.79 4.78.94.1.16 0 .2 0 .32a4.14 4.14 0 01-.96 3.24zm12.33 1.66c-2.86 0-4.85-.56-5.91-1.66a4.14 4.14 0 01-.97-3.24v-.26c.1-.21 1.2-1 4.77-1 3.1 0 4.55.71 4.78 1.01 0 1.6-.29 5.15-2.67 5.15z",
      "fill": "#DED1C2",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M47.04 27.67c-2.94 0-4.68.53-5.37 1.19a3.32 3.32 0 00-2.1-.56c-.44.04-.86.22-1.2.5-.72-.63-2.38-1.13-5.3-1.13-3.72 0-5.73.97-5.73 1.9 0 1.86.35 6.17 3.59 6.17 3.23 0 5.33-.66 6.6-1.96a5.05 5.05 0 001.2-4.05c.22-.28.55-.46.91-.49.6-.03 1.2.16 1.66.54v.07a5.05 5.05 0 001.2 3.93c1.26 1.3 3.47 1.96 6.6 1.96 3.13 0 3.58-4.31 3.58-6.18.1-.9-1.91-1.9-5.64-1.9zm-10.22 5.45c-1.06 1.11-3.05 1.66-5.9 1.66-2.4 0-2.68-3.58-2.7-5.14.25-.3 1.69-1.02 4.78-1.02 3.59 0 4.68.79 4.78.94.1.16 0 .2 0 .33a4.14 4.14 0 01-.96 3.23zm12.33 1.66c-2.86 0-4.85-.55-5.91-1.66a4.14 4.14 0 01-.97-3.27v-.26c.1-.22 1.2-1 4.77-1 3.1 0 4.55.71 4.78 1.01 0 1.64-.29 5.18-2.67 5.18z",
      "fill": "#5B2E21",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c25e75d","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/man/MentoringManIcon.vue
// module id = 5c81cfda54ce03917b12
// module chunks = 89